import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {} from '@angular/common/http';
import { NgModule } from '@angular/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatToolbarModule } from '@angular/material/toolbar';
import { SummitNavModule } from '@summit/nav';
import {LoadingAnimationModule, UtilMessageModule} from '@summit/utils';
import { WebUserInfoModule } from '@summit/web-user-info';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NewUserComponent } from './components/new-user/new-user.component';
import { ManageUserComponent } from './components/manage-user/manage-user.component';
import { ConfirmationComponent } from './components/confirmation/confirmation.component';
import { UserExistsComponent } from './components/new-user/user-exists-dialog/user-exists.component';
import { MatCardModule } from '@angular/material/card';

@NgModule({
    declarations: [
        AppComponent,
        NewUserComponent,
        ManageUserComponent,
        ConfirmationComponent,
        UserExistsComponent
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        MatToolbarModule,
        MatProgressBarModule,
        MatCardModule,
        SummitNavModule,
        UtilMessageModule,
        WebUserInfoModule,
        LoadingAnimationModule
    ],
    providers: [],
    bootstrap: [AppComponent]
})
export class AppModule { }
